<template>
    <a class="btn-wishlist" :href="urlWishList" rel="nofollow" :aria-label="$translate('Ceres::Template.wishList')">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" class="header__svg">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-wishlist"></use>
        </svg>
        <span class="ml-1 d-none d-sm-inline wishlist-badge">{{ wishListCount }}</span>
    </a>
</template>

<script>
export default {
    computed:
    {
        wishListCount()
        {
            return this.$store.getters.wishListCount;
        },

        urlWishList()
        {
            return App.urls.wishList;
        }
    }
}
</script>
